package site.shadadman.pages.worklog.marketmlm

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initDec182017MarketMLMPaymentMethodsPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/marketmlm/dec182017MarketMLMPaymentMethods.md", FrontMatterElement.Builder { addScalar("title", "18dec2017MarketmlmPaymentMethods"); }))
}

@Page("/worklog/marketmlm/dec182017-market-mlm-payment-methods")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun Dec182017MarketMLMPaymentMethodsPage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("dec-18-2017-MarketMLM-Payment-Methods")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This week at MarketMLM:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("We faced a new challenge. now at first you must know that current website platform was developed in woocommerce framework. because woocomerce offers a lot of local plugins , the current platform was a using a pirticuler plugin to create and show payment methods. Accessing this plugin data in order to make it an api and make it available in the client side was not possible. You can only create new payment methods via the admin panel & there is no global api in order to access that list. Of cource this was a challenge for our wordpress team. A decision was made to create a custom plugin for that section.")
        }
    }
}
